/**
 * Guía: Monitoreo del Servidor.
 *
 * Contenido derivado del capítulo **02** del manual —§0 (qué mide y que se
 * actualiza solo)— y del flujo F43, que es el que distingue esta pantalla de
 * la operativa.
 *
 * La guía es corta porque la pantalla no tiene acciones: su valor está en
 * saber cuál de los dos monitoreos abrir y qué significa cada bloque.
 */

import type { TourFlow } from '../types';

const SERVIDOR_PATH = '/server-monitoring';

export const c02MonitoreoServidor: TourFlow = {
  id: 'admin.server-monitoring',
  chapter: '02',
  title: 'Estado del servidor',
  summary:
    '¿La infraestructura aguanta? Qué mide cada bloque y cuándo esta pantalla no es la que hay que abrir.',
  href: SERVIDOR_PATH,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: '¿El servidor está sano ahora mismo?',
      body:
        'Ésa es la única pregunta que responde. Memoria y procesador del backend, estado de ' +
        'la base de datos y de la caché, tráfico y latencia, y el despliegue en curso. Se ' +
        'actualiza sola cada pocos segundos.',
      route: SERVIDOR_PATH,
    },
    {
      id: 'not-the-other-one',
      title: 'No es el Monitoreo Operativo',
      body:
        'Aquélla responde «cómo va el negocio» y se acota por país; ésta es global, porque ' +
        'la infraestructura es una sola. Si el síntoma es «va lento» o «no carga», es ésta. ' +
        'Si es «faltan pedidos» o «hay muchos pagos fallidos», es la otra.',
    },
    {
      id: 'metrics',
      title: 'Qué mirar cuando alguien reporta lentitud',
      body:
        'Procesador y memoria dicen si el servidor va ahogado; la base de datos y la caché, ' +
        'si el cuello está debajo. Si todo está sano y aun así alguien no puede operar, el ' +
        'problema es de esa cuenta o de ese comercio, no de la plataforma.',
      target: 'admin.serverMonitoring.metrics',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'read-only',
      title: 'Enseña estado; no arregla nada',
      body:
        'Desde aquí no se reinicia ni se despliega nada. Sirve para decidir si hay ' +
        'incidente y a quién avisar, que en los primeros minutos es lo único que importa.',
    },
  ],
};
